import { type DefaultRootState } from 'react-redux';

const defaultSpaceId = (state: DefaultRootState) => {
  return Object.values(state.spaceList.data || {}).find((item) => item.isDefault)?.id;
};

export default defaultSpaceId;
